import AboutUsContent from "$lib/data/generated/content/about us/data.json";

import { uploads as AboutUsUploads } from "$lib/data/generated/uploads/about us/uploads";

const content = {
	["about us"]: AboutUsContent
};
const uploads = {
	...AboutUsUploads
};


export const prerender = 'auto';
export const entries = () => {
	if (false) return [];
	return ['/admin'];
};

export const load = async ({ parent }) => {
	const data = await parent();

	data.content = { ...data.content, ...content };
	data.uploads = { ...data.uploads, ...uploads };

	return data;
};
